class HeaderLogo extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  /**
   * Obtiene el contenido a mostrar basado en la ruta actual
   */
  getContentBasedOnRoute() {
    const currentPath = window.location.pathname;
    const logoImage = this.getAttribute('logo-image');
    const logoText = this.getAttribute('logo-text') || 'Solo Media Group';

    // Si estamos en la ruta base '/', mostrar siempre el logo
    if (currentPath === '/') {
      return {
        type: logoImage ? 'image' : 'text',
        content: logoImage || logoText,
        alt: this.getAttribute('logo-alt') || logoText
      };
    }

    // Si estamos en una ruta /pages/algo, mostrar el nombre de la página
    const pagesMatch = currentPath.match(/^\/pages\/(.+)/);
    if (pagesMatch) {
      const pageName = pagesMatch[1];
      const processedName = this.processPageName(pageName);
      
      return {
        type: 'text',
        content: processedName,
        alt: processedName
      };
    }

    // Fallback: mostrar el logo normal
    return {
      type: logoImage ? 'image' : 'text',
      content: logoImage || logoText,
      alt: this.getAttribute('logo-alt') || logoText
    };
  }

  /**
   * Procesa el nombre de la página para formato de título
   */
  processPageName(pageName) {
    return pageName
      // Reemplazar guiones y guiones bajos con espacios
      .replace(/[-_]/g, ' ')
      // Capitalizar cada palabra
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  render() {
    // Preservar las clases existentes del elemento
    if (!this.className) {
      this.className = 'header-smg__logo';
    }
    
    const contentData = this.getContentBasedOnRoute();
    
    if (contentData.type === 'image') {
      this.innerHTML = `
        <img src="${contentData.content}" alt="${contentData.alt}" class="header-smg__logo-image">
      `;
    } else {
      this.innerHTML = `
        <div class="header-smg__logo-text">
          ${contentData.content}
        </div>
      `;
    }
  }
}

customElements.define('header-logo', HeaderLogo);